import { ConflictResolution } from '../../../@types/duplicateConflict';

// The warning job stores the original Excel mapping as a compact string in its payload.
// Because conflict resolution currently reuses /excel-imports/save/{importType}, the frontend
// has to rebuild the full save request, including excelMappingSuggestion. A dedicated backend
// endpoint that only accepts conflictJobId + entries would make this parser unnecessary.
const parseExcelMapping = (mappingPart: string): Record<string, number | null> => {
  if (!mappingPart) {
    return {};
  }

  return mappingPart
    .split(',')
    .map((entry) => entry.trim())
    .filter(Boolean)
    .reduce<Record<string, number | null>>((acc, entry) => {
      const [rawKey, rawValue] = entry.split('=');
      const key = rawKey?.trim();
      const value = rawValue?.trim();

      if (!key) {
        return acc;
      }

      const parsedValue = Number(value);
      acc[key] = Number.isNaN(parsedValue) ? null : parsedValue;

      return acc;
    }, {});
};

export const buildExcelCustomMappingFromJobPayload = (
  payload: string,
  conflictResolution: ConflictResolution
) => {
  const parts = payload.split('#');

  if (parts.length < 6) {
    throw new Error('Invalid Excel import job payload');
  }

  return {
    status: 'OK',
    uuid: parts[0],
    importEntityExcel: parts[1],
    importEntityId: parts[2] || null,
    errorStatus: null,
    excelHeaders: [],
    excelMappingSuggestion: parseExcelMapping(parts[5]),
    conflictResolution,
  };
};
